import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const materialResourceUrl = `${SERVER_API}/material-resource`;
